
<template>
  <v-card class="my-2 fill-height" outlined>
    <v-card-text class="d-flex fill-height">
      <div class="d-flex align-center justify-center mr-3">
        <v-avatar size="50" :color="color">
          <v-icon class="white--text">{{icon}}</v-icon>
        </v-avatar>
      </div>
      <v-sheet width="100%" class="d-flex justify-center align-center text-center">
        <slot name="content"></slot>
      </v-sheet>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'InfoCard',
  mixins: [],
  props: {
    icon: {
      type: String
    },
    color: {
      type: String
    },
  },
}
</script>